<template>
  <router-view />
</template>
<script>
export default {
  name: "AuthContainer"
};
</script>
